import { ChangeDetectionStrategy, Component, inject, input, output, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ApiTypes, TrackingFeature } from '@hyundai/ng-common-lib';
import { Store } from '@ngrx/store';
import DistributionContactTemplateComponent from '../distribution-contact-template/distribution-contact-template.component';
import { DistributionForm } from '../distribution-overview-step/distribution-overview-step.component';

@Component({
    selector: 'lib-distribution-reservation-step',
    standalone: true,
    templateUrl: './distribution-reservation-step.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DistributionContactTemplateComponent],
})
export default class DistributionReservationStepComponent {
    store = inject(Store);
    vehicle = input.required<ApiTypes.VehicleDetail>();
    form = input.required<FormGroup<DistributionForm>>();
    errorMsg = input<string>();
    submitClicked = output();

    trackingStarted = false;

    trackingStart(): void {
        if (this.form().controls.tab.value !== 'reservierung' || this.trackingStarted) {
            return;
        }
        this.trackingStarted = true;
        this.store.dispatch(TrackingFeature.actions.formReservationStartTracking({ vehicle: this.vehicle() }));
    }
}
